/*
 * Author: harper
 * File Created: Wednesday, 24-07-03 11:03 pm
 * Last Modified: Friday, 24-12-06 02:49 pm, by Harper Yan
 */

import { GoogleTagManager } from '@next/third-parties/google';
const Gtm = () => {
  return <>
      {process.env.NEXT_PUBLIC_GTM_TRACKING_ID && <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_TRACKING_ID} />}
    </>;
};
export default Gtm;